<template>
    <div id="contractsComponent" class="">
        <div class="titleContract">
            <h1 class="titleContracth1">Necesidades</h1>
        </div>
        <div class="containerContract">
            <!-- Filtro -->
            <contractFilter ref="filterComponent" v-model="filterModel"
                @on-filter-click="filterTable"
                @on-borrar-click="borrarFiltros"/>
            <!-- Buscador -->
            <div>
                <p class="subTitleContracts">Datos</p>
                <div class="divExcel">
                    <vue-excel-xlsx id="excelBtn" :data="excelData" :columns="excelColumns" :filename="'Contratos'" :sheetname="'Contratos'">
                        Excel
                    </vue-excel-xlsx>
                </div>
                <b-row>
                    <b-col cols="12" sm="7" md="6" lg="6" xl="6">
                        <b-row class="divMostar">
                            <b-col cols="3" sm="3" md="2" lg="2" xl="2" >
                                <p>Mostrar:</p>
                            </b-col>
                            <b-col cols="9">
                                <b-form-select class="form-control input-sm mostrarSelect" v-model="tableSize" :options="tableSizes"/>
                                registros
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" sm="5" md="6" lg="6" xl="6">
                        <b-row class="divBuscar">
                            <b-col cols="3" sm="3" md="2" lg="2" xl="2" offset-sm="3" offset-md="4" offset-lg="4" offset-xl="6">
                                <p>Buscar:</p>
                            </b-col>
                            <b-col cols="6" sm="6" md="6" lg="6" xl="4">
                                <b-form-input
                                    type="text"
                                    v-model="searchPattern"
                                    @input="searchInTable"
                                    />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

            </div>

            <!-- Tabla-->
            <contractTable v-model="tableItems"
                :itemsPerPage="tableSize"
                :pageIndex="currentPage"
                :tabletMode="isTabletMode"
                ref="contractTable"
                @on-filter-click="filterTable"
            />
            <div class="overflow-auto">
                <div class="paginatorStatus">
                    Mostrando registros del {{numOfCurrIndex}} al {{numOfLastIndex}} de un total de {{tableItems.length}} registros
                </div>
                <b-pagination
                    id="paginator-contracts"
                    v-model="currentPage"
                    :total-rows="tableItems.length"
                    :per-page="tableSize"
                    class="paginatorPages">
                </b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import contractFilter from '@/components/contracts/contracts-filter'
import contractTable from '@/components/contracts/contracts-table'

export default {
  name: 'contracts',
  components: {
    contractFilter,
    contractTable
  },
  data(){
    return{
      filterModel: {},
      searchPattern: null,
      tableSize: this.$constants.contractTableDefaultSize,
      tableSizes: this.$constants.contractTableSizes,
      isTabletMode: false,
      conctractTableItems: [],
      tableItems: [],
      currentPage: this.$constants.contractTableDefaultPage,
      excelColumns:[],
      excelData:[],
      spiner: false
    }
  },
  created() {
    if(this.$session.has("token")){ this.token = this.$session.get("token")}
    else{this.redirect()}
    this.refactorEnv = this.$session.get("settings")
    window.addEventListener("resize", this.handleContracts);
  },
  mounted() {
    this.getTableRows();
    this.handleContracts();
  },
  computed: {
    numOfCurrIndex() {
      return (this.tableItems.length == 0) ? 0 : ((this.currentPage - 1) * this.tableSize) + 1;
    },
    numOfLastIndex() {
      var lastPageIndex = this.currentPage * this.tableSize;
      return (this.tableItems.length < lastPageIndex) ? this.tableItems.length : lastPageIndex;
    }
  },
  methods: {
    handleContracts() {
      this.isTabletMode = window.innerWidth < this.$constants.minSizeTablet;
    },
    getExcelData(){
      this.excelData = [];
      this.tableItems.forEach(item =>{
        let r = {};
        this.excelColumns.forEach(column =>{
          switch(column.field){
            case 'status': r[column.field] = item[column.field].code; break;
            default: r[column.field] = item[column.field];
          }
        })
        this.excelData.push(r);
      },this)
    },
    getExcelColumns(){
      this.excelColumns = [];
      this.$refs.contractTable.tablePCHeaders.forEach(header => {
        if(header.key != 'docs' && header.key != 'doc_final'){
          this.excelColumns.push({label:header.name, field:header.key});}
      },this)
    },
    async getTableRows() {
      this.$emit('changeSpinner', true)
      var token = this.token
      this.filterModel.cod_client = this.$constants.cod_cliente
      this.filterModel.n_page = this.$constants.currentPage
      this.filterModel.n_elements = this.$constants.maxTableItems
      if(this.filterModel.id_contract){
        this.filterModel.id_contract =("" + parseInt(this.filterModel.id_contract))
      }
      if(this.filterModel.status){
        var statusObj = this.filterModel.status
      }
      this.filterModel.idUser =  this.$session.get("id")
      this.fixEndDates(this.filterModel);
      if(this.filterModel.serv ==""){
        delete this.filterModel['serv'] }
      await this.$http.post(this.refactorEnv.listContracts, this.filterModel,{ headers: {
        'Authorization': token}}).then(response => {
        this.tableItems =  response.body.data.contracts;
        this.conctractTableItems = response.body.data.contracts.map(contract =>{
            return contract;
        })
        this.getExcelColumns();
        this.getExcelData();
        this.filterModel.status = statusObj
      }).catch(error => {console.log(error)});
      this.$emit('changeSpinner', false)
    },
    async filterTable() {
      await this.getTableRows();
      this.searchInTable();
    },
    async borrarFiltros() {
      this.$refs.filterComponent.borrarFiltros();
      await this.filterTable();
    },
    fixEndDates(filters){
      if(filters.end_fecha_reg && filters.end_fecha_reg.indexOf("23:59:59") == -1){
        this.filterModel.end_fecha_reg = filters.end_fecha_reg + " 23:59:59";
      }
    },
    searchInTable() {
      var self = this;
      var auxArray = []
      if (this.searchPattern) {
        this.conctractTableItems.forEach(function(value, index, array) {
          var found = false;
          var i = 0;
          while (!found && i < self.$constants.contractTableHeaders.length) {
            var key = self.$constants.contractTableHeaders[i].key;
            var isSearchableKey = self.$constants.contractTableHeaders[i].isSearchable;
            if (isSearchableKey) {
              if(typeof value[key] == 'object' ){
                if(!self.isEmpty(value[key])){
                  found = value[key]['code'].toString().includes(self.searchPattern)
                }
              }else{
                found = value[key].toString().includes(self.searchPattern)
              }
            }
            i++;
          }
          if (found) {
            auxArray.push({...value});
          }
        });
      } else {auxArray = this.conctractTableItems.map(obj => ({...obj}));}
      this.tableItems = auxArray;
      this.orderById()
    },
    redirect() {
      this.$session.destroy()
      this.$router.push({
        name: "login"
      });
    },
    isEmpty(value) {
      return (value === undefined || value == null || value.length <= this.$constants.lengthZero) ? true : false;
    },
    orderById(){
      this.tableItems.sort(function (item1, item2) {
        var param1 = parseInt(item1['id'])
        var param2 = parseInt(item2['id'])
        if ( param1 > param2){return -1;}
        if (  param1 < param2){return 1;}
        return 0;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/contracts.vue